<template>
    <h5>
        {{ componentTitle }}
    </h5>

    <span v-html="componentContent">
    </span>

    <hr />
</template>

<script>
export default {
    name: "ComponentItemPrintable",

    props: {
        component: {
            type: Object,
            required: true,
        },

        languageId: {
            type: [Number, String],
            default: null,
        },
    },

    computed: {
        hasTranslation() {
            return (this.component.translations && this.component.translations.length);
        },

        componentTitle() {
            return (this.hasTranslation ? this.component.translations[0].title : this.component.title);
        },

        componentContent() {
            return (this.hasTranslation ? this.component.translations[0].content : this.component.content);
        },
    },
};
</script>

<style>
    .type-reflect
    {
        background-color: #FFF799;
    }
</style>
